//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'dataCount',
  components:{
  },
  data () {
    return {
      list:[
        {
          title:'洗衣店普通商品统计',
          path:'/goodsCount',
        },
        {
          title:'洗衣店团购商品统计',
          path:'/goodsGroupCount',
        },
        {
          title:'洗衣店各项收入统计',
          path:'/goodsAmountCount',
        },
      ]
    }
  },
  created(){
  },
  mounted(){
  
  },
  methods:{
  
  }
}



// WEBPACK FOOTER //
// ./src/pages/dataCount.vue